import { useCompanyInfo } from "hooks";
import { useRefetchWithTTL } from "hooks/use-refetch-with-ttl";
import { useMainCategory } from "hooks/useMainCategory";
import { TTL } from "utils/constants";

export const GlobalAPICalls = () => {
  const { getCompanyInfoRequest, lastFetchedInfoDataAt } = useCompanyInfo();
  const { getMainCategories, lastFetchedMainCategoriesAt } = useMainCategory();

  useRefetchWithTTL({
    lastFetched: lastFetchedInfoDataAt,
    ttl: TTL.semiStatic,
    fetchAction: () => getCompanyInfoRequest(),
  });

  useRefetchWithTTL({
    lastFetched: lastFetchedMainCategoriesAt,
    ttl: TTL.semiStatic,
    fetchAction: () => getMainCategories(),
  });

  return null;
};
